"use strict";

const removeAllHyphens = str => {
  // Use regular expression to match and replace all hyphens with an empty string
  return str.replace(/-/g, '');
};
module.exports = {
  removeAllHyphens
};